import React from 'react';
import { NewspaperIcon } from '@heroicons/react/24/outline';

const Posts: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Posts</h1>
      <p className="section-description">
        Manage blog posts and articles with comprehensive content management features, including rich text editing, media management, and SEO optimization.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <NewspaperIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Post Management</h3>
              <p className="feature-description">
                Handle posts with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Create and edit posts with rich text editor</li>
                <li>Upload and manage featured images</li>
                <li>Set post status (Draft, In Review, Published)</li>
                <li>Delete individual posts</li>
                <li>Bulk delete multiple posts</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <NewspaperIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Content Organization</h3>
              <p className="feature-description">
                Organize and structure your content:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Category management (create/edit categories)</li>
                <li>Featured post designation</li>
                <li>Publication scheduling</li>
                <li>Excerpt management</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <NewspaperIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Post List</h3>
              <p className="feature-description">
                View and manage posts in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Featured image thumbnail</li>
                <li>Title (searchable, sortable)</li>
                <li>Category (searchable, sortable)</li>
                <li>Featured status (sortable)</li>
                <li>Post status (color-coded badges)</li>
                <li>Publication date (sortable)</li>
                <li>View count (sortable)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <NewspaperIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">SEO & Publishing</h3>
              <p className="feature-description">
                Optimize and control post visibility:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Meta title (50-60 characters recommended)</li>
                <li>Meta description (150-160 characters recommended)</li>
                <li>Publication status toggle</li>
                <li>Publication date scheduling</li>
                <li>Bulk status updates</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Use clear, descriptive titles and excerpts</li>
            <li>Optimize meta titles and descriptions for SEO</li>
            <li>Regularly update and maintain categories</li>
            <li>Schedule posts for optimal publication times</li>
            <li>Use high-quality featured images</li>
            <li>Monitor post performance through view counts</li>
            <li>Keep content fresh and up-to-date</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Posts; 